const ExerciseTypes = {
  0: 'Upper Body',
  1: 'Lower Body',
  2: 'Core',
  3: 'Stretch',
  4: 'Mobility'
};


export default ExerciseTypes;